module.exports = __webpack_public_path__ + "static/img/101367.fa98cf34.png";